// extracted by mini-css-extract-plugin
export const grid = "weapons-module--grid--cQerX";
export const weaponContent = "weapons-module--weaponContent--1UNaw";
export const weaponNav = "weapons-module--weaponNav--3BIpo";
export const navigation = "weapons-module--navigation--1g3GG";
export const active = "weapons-module--active--318KG";